import React, { useState } from 'react'
import { Button, Typography, useDimensions } from '@telavita-core/react-design-kit'

import { FreeAndPrivacyDisclaimerModal } from '../FreeAndPrivacyDisclaimerModal'

import { ReactComponent as FreeChargeIcon } from 'static/svg/free-and-privacy-disclaimer-icons/free-charge-icon.svg'
import { ReactComponent as PrivacyLockIcon } from 'static/svg/free-and-privacy-disclaimer-icons/privacy-lock-icon.svg'

import * as S from './styles'

export const FreeAndPrivacyDisclaimerText = (): JSX.Element => {
  const { isMobile } = useDimensions()
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <S.Container isMobile={isMobile}>
        <S.IconsWrapper isMobile={isMobile}>
          <PrivacyLockIcon />
          <FreeChargeIcon />
        </S.IconsWrapper>

        <S.TextWrapper isMobile={isMobile}>
          <Typography center variant='content2'>
            Aproveite seu benefício sem nenhuma preocupação.
          </Typography>
          <Button 
            variant='text' 
            uppercase={false}
            onClick={() => setShowModal(true)}
          >
            Saiba mais
          </Button>
        </S.TextWrapper>
      </S.Container>
      {showModal && (
        <FreeAndPrivacyDisclaimerModal 
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  )
}